import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import UserLayout from '../../../components/user-layout/UserLayout';
import authService, { user$ } from '../../../utils/services/authService';
import ticketService from '../../../utils/services/ticketService';

import styles from './ticketPage.module.scss';

const TicketPage = () => {
  const [user, setUser] = useState();
  const [formData, setFormdata] = useState({
    category: '',
    subject: '',
    issue: '',
    user: {
      id: '',
      name: '',
      email: '',
      role: '',
    },
    createdAt: new Date(),
  });
  const [isFormFilled, setIsFormFilled] = useState(false);
  const [message, setMessage] = useState('');

  const navigate = useNavigate();
  const userData = authService.getUserData();

  useEffect(() => {
    authService.getUserById(userData);
    user$.subscribe((data) => {
      if (data) {
        setUser(data.data.data[0]);
      }
    });
    if (formData.category && formData.subject && formData.issue) {
      setIsFormFilled(true);
    } else {
      setIsFormFilled(false);
    }
  }, [formData]);

  useEffect(() => {
    if (isFormFilled) {
      const info = {
        id: user._id,
        name: user.name || user.companyName,
        email: user.email,
        role: user.role,
      };
      if (isFormFilled) {
        setFormdata({
          ...formData,
          user: { ...formData.user, ...info },
        });
      } else {
        setMessage('All fields must be filled in');
      }
    }
  }, [isFormFilled]);

  const onChangeHandler = (e) => {
    const value = e.target.value;
    setFormdata({
      ...formData,
      [e.target.name]: value,
    });
  };

  const onSubmitHandle = (e) => {
    e.preventDefault();

    ticketService.createTicket(formData, userData).then((res) => {
      if (res?.data.success) {
        if (userData.role === 'developer') {
          navigate(`/profile/developer/${userData.userId}`);
        } else if (userData.role === 'company') {
          navigate(`/profile/company/${userData.userId}`);
        }
      }
    });
  };
  return (
    <UserLayout>
      <section className={styles.ticketPageWrapper}>
        <h1 className={styles.ticketPageWrapper_heading}>
          Tell us what's wrong
        </h1>
        {message !== '' ? <p>{message}</p> : ''}

        <form
          className={styles.ticketForm}
          onSubmit={(e) => {
            onSubmitHandle(e);
          }}
        >
          <div className={styles.formGroup}>
            <label className={styles.formGroup_label} htmlFor="select">
              Select category *
            </label>
            <select
              className={styles.formGroup_select}
              name="category"
              id="select"
              onChange={(e) => {
                onChangeHandler(e);
              }}
            >
              <option value="">Select a category</option>
              <option value="technical">Technical</option>
              <option value="account">Account</option>
              <option value="bugs">Report a bug</option>
            </select>
          </div>
          <div className={styles.formGroup}>
            <label className={styles.formGroup_label} htmlFor="subject">
              Subject *
            </label>
            <input
              id="subject"
              className={styles.formGroup_input}
              type="text"
              name="subject"
              onChange={(e) => {
                onChangeHandler(e);
              }}
            />
          </div>
          <div className={styles.formGroup}>
            <label className={styles.formGroup_label} htmlFor="issue">
              Issue *
            </label>
            <textarea
              id="issue"
              className={styles.formGroup_textarea}
              type="text"
              name="issue"
              onChange={(e) => {
                onChangeHandler(e);
              }}
            />
          </div>
          <div className={styles.formGroup}>
            <button
              disabled={!isFormFilled}
              className={styles.formGroup_btn}
              type="submit"
            >
              Send
            </button>
          </div>
        </form>
      </section>
    </UserLayout>
  );
};

export default TicketPage;
